// extracted by mini-css-extract-plugin
module.exports = {"thecomp":"Recommend_thecomp__M_o8G"};